import dayjs from 'dayjs'
import Section from '@audioeye-marketing/ui/src/components/Section'
import Container from '@audioeye-marketing/ui/src/components/Container'
import Grid from '@audioeye-marketing/ui/src/components/Grid'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import Link from '@audioeye-marketing/ui/src/components/Link'
import Typography from '@audioeye-marketing/ui/src/components/Typography'
import Chip from '@audioeye-marketing/ui/src/components/Chip'
import Box from '@audioeye-marketing/ui/src/components/Box'
import colors from '@audioeye-marketing/ui/src/theme/colors'
import Edit04 from '@audioeye/ui-icons/Line/General/Edit04'
import Image from '@/components/storyblok/items/Image'
import translateSectionStyles from '@/lib/translate-section-styles'

const PostHero = ({ author, publishedDate, updatedDate, title, summary, image, topics = [] }) => {
  const sectionStyles = translateSectionStyles({ background_color: { value: colors.neutral[50] } })
  const blogDate = updatedDate !== publishedDate ? updatedDate : publishedDate

  return (
    <Section {...sectionStyles}>
      <Container constraint="lg">
        <Grid direction="row" container spacing={{ xs: 5, md: 10 }}>
          <Grid xs={12} md={6}>
            <Stack justifyContent="center" sx={{ height: '100%' }}>
              <Stack spacing={1} sx={{ mb: 4 }}>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  <Box sx={{ marginTop: '4px !important', marginBottom: '4px !important' }}>
                    <Chip startDecorator={<Edit04 />} variant="soft" color="primary">
                      Blog
                    </Chip>
                  </Box>
                  {topics?.map((topic) => (
                    <Box key={topic} sx={{ marginTop: '4px !important', marginBottom: '4px !important' }}>
                      <Chip variant="soft" color="success">
                        {topic}
                      </Chip>
                    </Box>
                  ))}
                </Stack>
                {Boolean(title) && (
                  <Typography level="h1" displayMedium sx={{ mb: 1 }}>
                    {title}
                  </Typography>
                )}
                {Boolean(summary) && <Typography>{summary}</Typography>}
              </Stack>
              <Stack spacing={1}>
                <Stack direction="row" spacing={1}>
                  <Typography level="body-sm">
                    Author:{' '}
                    <strong>
                      <Link href={`/${author?.full_slug}/`}>{author?.content?.name}</Link>
                    </strong>
                    {Boolean(author?.content?.title) && `, ${author?.content?.title}`}
                  </Typography>
                </Stack>
                <Stack spacing={1} direction={{ xs: 'column', sm: 'row' }}>
                  {Boolean(publishedDate) && (
                    <Typography level="body-sm">
                      Published: {dayjs(blogDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY')}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Grid>
          <Grid xs={12} md={6}>
            <Stack sx={{ height: '100%' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="center">
              <Image blok={{ image }} imagePriority showAltText />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Section>
  )
}

export default PostHero
